import { render, staticRenderFns } from "./ModalConfirmationLogoutDesktop.vue?vue&type=template&id=771dce4c&scoped=true"
import script from "./ModalConfirmationLogoutDesktop.vue?vue&type=script&lang=js"
export * from "./ModalConfirmationLogoutDesktop.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmationLogoutDesktop.vue?vue&type=style&index=0&id=771dce4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771dce4c",
  null
  
)

export default component.exports